import {generateFullUrl} from "services/utils/utils";
import {get} from "lodash";
import {Comment} from "mapping/comment";

export const Thread = {
    fromServer: (data) => {
        const thread = data.thread;
        const user_stats = data.user_stats;
        const author = data.author;
        return {
            id: thread.id,
            title: thread.title,
            message: thread.message,
            type: thread.type,
            creation_date: thread.created_at,
            update_date: thread.updated_at,
            user_name: author.name,
            favorite: user_stats.favorite,
            avatar: generateFullUrl(author.avatar),
            categories: data.categories,
            number_of_responses: data.comments_count,
            last_answer: data.last_activity_at,
            attachment: generateFullUrl(thread.attachment),
            like: user_stats.liked,
            likes: {
                total: data.likes,
                avatars: data.lastLikesAvatars.map(generateFullUrl)
            },
            is_archived: thread.is_archived,
            is_mine: get(data, 'is_own', false),
            can_comment: get(data, 'can_comment', true),
            best_answer: data.best_answer ? Comment.fromServer(data.best_answer) : null
        }
    },
    toServer: (data) => {
        return {
            ...data
        }
    }
}